angular.module("KhBase").factory("PlatformTerminologyFactory", ["$resource", function ($resource) {
    return $resource('api/v1.0/platform/ui/platform-terminology/:app_name/', {
        get: {
            method: 'GET'
        }
    });
}]);
